module.exports = __webpack_public_path__ + "house_with_key.b992d058df7d9b954b8f127ef4f4ba3a.svg";